import {useForm, SubmitHandler} from "react-hook-form"
import {Link, useNavigate} from "react-router";
import {fetchJson} from "../../utils";
import {useState} from "react";
import {UserType} from "../../types";
import PopularVideoStories from "../../blocks/pupular-video-stories";

type Inputs = {
    email: string
    password: string
}

type SignUpResponse = {
    success: boolean;
    user?: UserType;
    field?: keyof Inputs; // Fields that might receive an error
    message?: string;
};

type SignUpProps = {
    redirectTo?: string
}

export const SignUp = ({
    redirectTo = '/account'
}: SignUpProps) => {

    const [submitting, setSubmitting] = useState(false);
    const navigate = useNavigate();
    const {
        register,
        handleSubmit,
        formState: {errors},
        setError
    } = useForm<Inputs>();
    const onSubmit: SubmitHandler<Inputs> = (data) => {

        setSubmitting(true);
        fetchJson<SignUpResponse>('/api/sign-up', {
            method: 'POST',
            body: JSON.stringify(data)
        })
            .then(({json}) => {
                if (json.success) {
                    navigate(redirectTo);
                } else if (json.field) {
                    setError(json.field, {
                        type: 'manual',
                        message: json.message
                    }, {
                        shouldFocus: true
                    })

                }
            })
            .finally(() => {
                setSubmitting(false);
            });

    }

    return (<>
    <section className="section">
        <div className="inside-wrapper">
            <h1 className="section__title">
                Create Your Account
            </h1>
            <div className="signbox">
                <div className="signbox__form form">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className={`form__row ${errors.email && 'is-error'}`}>
                            <label className="form__label">
                                Email Address
                            </label>
                            <div className="form__input-holder">
                                <input type="email" className="form__input" {...register('email', {
                                    required: 'Email is required',
                                    pattern: {
                                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                        message: 'Invalid email address'
                                    }
                                })} />
                            </div>
                            {errors.email && <div className="form__alert">{errors.email.message}</div>}
                        </div>
                        <div className={`form__row ${errors.password && 'is-error'}`}>
                            <label className="form__label">
                                Password
                            </label>
                            <div className="form__input-holder">
                                <input type="password" className="form__input" {...register('password', {
                                    required: 'Password is required',
                                    minLength: {
                                        value: 6,
                                        message: 'Password must be at least 6 characters long'
                                    }
                                })} />
                            </div>
                            {errors.password && <div className="form__alert">{errors.password.message}</div>}
                        </div>
                        <div className="form__row form__row_extragap form__note">
                            By&nbsp;registering an&nbsp;account you automatically agree with our <br/>
                            <a href="/pages/terms-of-service">Terms of&nbsp;use</a> and <a
                            href="/pages/privacy-policy">Privacy policy</a>
                        </div>
                        <div className="form__row form__row_smallgap form__btns">
                            <button className="btn btn_cta btn_lg btn_extrapad" disabled={submitting} type="submit">Continue</button>
                        </div>
                        <div className="form__row form__row_smallgap form__note">
                            Already have an&nbsp;Account? &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <Link to="/sign-in">Sign&nbsp;In</Link>
                        </div>
                    </form>
                </div>
                <div className="signmore">
                    <div className="signmore__label">
                        <div className="signmore__label-text">OR</div>
                    </div>
                    <div className="signmore__btns">
                        <a href={`/auth/google?return=${redirectTo}`} className="btn btn_sign">
                            <img src="./img/s_google.svg" className="btn__sign-ico" alt="Google"/>
                            Sign Up with Google
                        </a>
                        <a href={`/auth/facebook?return=${redirectTo}`} className="btn btn_sign">
                            <img src="./img/s_facebook.svg" className="btn__sign-ico" alt="Facebook"/>
                            Sign Up with Facebook
                        </a>
                        <a href={`/auth/microsoft?return=${redirectTo}`} className="btn btn_sign">
                            <img src="./img/s_microsoft.svg" className="btn__sign-ico" alt="Microsoft"/>
                            Sign Up with Microsoft
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <PopularVideoStories />
    </>)
};

export default SignUp;